import { Card } from "primereact/card";
import { Checkbox } from "primereact/checkbox";
import CustomDropdown from "../../components/forms/CustomDropdown";
import { studentStatusesApi } from "../../services/nomenclatures/studentStatusesApi";
import { useState } from "react";
import { ProtocolStudentFilter } from "../../models/dtos";
import CustomInputText from "../../components/forms/CustomInputText";
import { Button } from "primereact/button";

interface ProtocolStudentsFilterProps {
  initialFilter: ProtocolStudentFilter;
  onFilterChange: (filter: ProtocolStudentFilter) => void;
}

const ProtocolStudentsFilter = ({ initialFilter, onFilterChange }: ProtocolStudentsFilterProps) => {
  const { data: studentStatuses } = studentStatusesApi.useGetStudentStatusesQuery();

  const [formValues, setFormValues] = useState(initialFilter);

  const handleFormChange = (key: string, value: any) => {
    setFormValues((prev) => ({ ...prev, [key]: value }));
  };

  const handleSearch = () => {
    onFilterChange(formValues);
  };

  const handleClear = () => {
    const emptyFilter: ProtocolStudentFilter = {
      showHigherSemesterStudents: false,
      showForeignStudents: true,
      showStudyingInEnglish: false,
      studentStatusId: undefined,
      studentFnOrName: "",
    };
    setFormValues(emptyFilter);
    onFilterChange(emptyFilter);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <Card className="mb-3">
      <div className="flex flex-wrap gap-4 align-items-center" onKeyDown={handleKeyDown}>
        <div className="flex align-items-center">
          <Checkbox
            checked={formValues.showHigherSemesterStudents}
            onChange={(e) => handleFormChange("showHigherSemesterStudents", e.checked)}
          />
          <label className="ml-2">Студенти от по-горен семестър</label>
        </div>

        <div className="flex align-items-center">
          <Checkbox
            checked={formValues.showForeignStudents}
            onChange={(e) => handleFormChange("showForeignStudents", e.checked)}
          />
          <label className="ml-2">Чуждестранни студенти</label>
        </div>

        <div className="flex align-items-center">
          <Checkbox
            checked={formValues.showStudyingInEnglish}
            onChange={(e) => handleFormChange("showStudyingInEnglish", e.checked)}
          />
          <label className="ml-2">Обучаващи се на английски</label>
        </div>

        <div className="flex-1">
          <CustomDropdown
            id="studentStatusId"
            label="Статус на студент"
            options={studentStatuses?.data || []}
            optionLabel="name"
            optionValue="studentStatusId"
            value={formValues.studentStatusId ?? null}
            onChange={(e: any) => handleFormChange("studentStatusId", e.value)}
            showClear
            onKeyDown={handleKeyDown}
          />
        </div>

        <div className="flex-1">
          <CustomInputText
            id="studentFnOrName"
            label="Име или факултетен номер"
            showClear
            value={formValues.studentFnOrName ?? null}
            onChange={(e: any) => handleFormChange("studentFnOrName", e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>
      </div>
      <div className="flex justify-content-center mt-3">
        <Button label="Търсене" onClick={handleSearch} />
        <Button label="Изчисти" className="ml-2" severity="secondary" onClick={handleClear} />
      </div>
    </Card>
  );
};

export default ProtocolStudentsFilter;
